import React from 'react';

const PageShell = Page => {
  return props =>

    <div
    >
      <div className="outer">
        <div className="middle bg-banner">
          <Page {...props} />
        </div>
      </div>

    </div>

};

export default PageShell;
